import axios from "axios";
import { ApiClientConfig } from "../auth/ApiClientConfig";
import { GetAxiosHeaders } from "../auth/GetAxiosHeaders";
import {
  LabDto,
  LabsClient,
  LabsOnDemandClient,
  UserOnDemandLabRequestDto,
} from "../lib/ShiOneClient";

const labsClient = new LabsClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT,
);

const labsOnDemandClient = new LabsOnDemandClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT,
);

export const labsApi = {
  getAllLabs: () => labsClient.getAllLabsFromSharepoint(),
  getLabsDefinition: async () => {
    const headers = await GetAxiosHeaders();
    const response = await axios.get<LabDto[]>(
      `${import.meta.env.API_ENDPOINT}/api/Labs/definitions`,
      { headers },
    );
    return response.data.map((lab) => LabDto.fromJS(lab));
  },
  getLabFilterOptions: () => labsClient.getLabFilterOptions(),
  requestLabAccess: (lab: LabDto) => labsClient.requestLabAccess(lab as any), // cast if needed
  downloadLabDocumentation: (fileRef: string) =>
    labsClient.downloadLabDocumentation({ fileRef }),
  getUserLabsData: () => labsOnDemandClient.getUserLabsData(),
  createUserOnDemandLabRequests: (req: UserOnDemandLabRequestDto) =>
    labsOnDemandClient.createUserOnDemandLabRequests(req),
  createOnDemandLabForUser: (uniqueLabIdentifier: string) =>
    labsOnDemandClient.createOnDemandLabForUser(uniqueLabIdentifier),
};
